<!-- eslint-disable -->
<template>
    <!--begin::Advance Table Widget 5-->
    <div class="card card-custom gutter-b">
        <!--begin::Header-->
        <div class="card-header border-0 py-5">
            <h3 class="card-title align-items-start flex-column">
                <span class="card-label font-weight-bolder text-dark">Архив заказов</span>
            </h3>
        </div>
        <!--end::Header-->

        <!--begin::Body-->
        <div class="card-body pt-0">

            <div v-if="orders.length === 0" class="text-center mb-10">
                Заказы не найдены!
            </div>

            <div v-if="load" class="text-center mb-10">
                <b-spinner variant="primary" label="Text Centered"></b-spinner>
            </div>

            <b-form v-else>

                <!--begin::Table-->
                <div class="table-responsive">
                    <table class="table table-head-custom table-vertical-center" id="kt_advance_table_widget_2">
                        <thead>
                        <tr class="text-uppercase">
                            <th class="pl-0" style="width: 40px">
                                <label class="checkbox checkbox-lg checkbox-inline mr-2">
                                    <input type="checkbox"
                                           v-model="selectAll"
                                    />
                                    <span></span>
                                </label>
                            </th>
                            <th class="pl-0">#</th>
                            <th style="min-width: 120px">Клиент</th>
                            <th style="min-width: 150px">Дата заказа</th>
                            <th style="min-width: 150px">Итого</th>
                            <th style="min-width: 130px">Статус</th>
                            <th class="pr-0 text-right" style="min-width: 160px">Действия</th>
                        </tr>
                        </thead>
                        <tbody>
                        <template v-for="(order, i) in orders">
                            <tr v-bind:key="i">
                                <td class="pl-0 py-6">
                                    <label class="checkbox checkbox-lg checkbox-inline">
                                        <input type="checkbox"
                                               v-model="selected"
                                               :value="order.id"
                                        />
                                        <span></span>
                                    </label>
                                </td>
                                <td class="pl-0">
                                    <a class="text-dark-75 font-weight-bolder text-hover-primary font-size-lg">{{order.id}}</a>
                                </td>
                                <td>
                                    <span v-if="order.client" class="text-dark-75 font-weight-bolder d-block font-size-lg">
                                         <router-link :to="{ name: 'Client', params: {id: order.client.id}}">
                                            {{ order.client.name + ' ' + order.client.surname }}
                                        </router-link>
                                    </span>
                                </td>
                                <td>
                                    <span class="text-dark-75 font-weight-bolder d-block font-size-lg">
                                        {{ moment(order.created_at).format('lll') }}
                                    </span>
                                </td>
                                <td>
                                    <span class="text-dark-75 font-weight-bolder d-block font-size-lg">
                                        {{ numberWithSpaces(order.payment.sum) }} <i class="text-dark icon-nm fas fa-ruble-sign"></i>
                                    </span>
                                </td>

                                <td>
                                    <span v-if="order.status.name === 'Обработка'" class="label label-lg label-light-warning label-inline">{{order.status.name}}</span>
                                    <span v-else-if="order.status.name === 'Выполнен'" class="label label-lg label-light-success label-inline">{{order.status.name}}</span>
                                    <span v-else-if="order.status.name === 'Отменен'" class="label label-lg label-light-danger label-inline">{{order.status.name}}</span>
                                    <span v-else class="label label-lg label-light-primary label-inline">{{order.status.name}}</span>
                                </td>

                                <td class="pr-0 text-right">
                                    <b-link @click="restoreOrder(order.id)" v-b-tooltip.hover title="Восстановить заказ" class="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"><i class="fas fa-trash-restore"></i></b-link>
                                </td>

                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>

                <div class="row align-items-center mb-3">
                    <div class="col-lg-12 col-xl-12">
                        <div class="row align-items-center">
                            <div class="col-md-4 my-2 my-md-0">
                                <b-form-select
                                        class="mb-2 mr-sm-2 mb-sm-0"
                                        :value="null"
                                        v-model="actions"
                                >
                                    <option :value="null">Выберите действие</option>
                                    <option value="restore">Восстановить выбранные заказы</option>
                                </b-form-select>
                            </div>
                            <div class="col-md-4 my-2 my-md-0">
                                <b-button @click="moreActions" variant="primary">Применить</b-button>
                            </div>
                        </div>
                    </div>
                </div>

                <Paginate :route_link="'ArchiveOrder'" :filter="filter" />

            </b-form>
            <!--end::Table-->




        </div>
        <!--end::Body-->



    </div>
    <!--end::Advance Table Widget 5-->
</template>

<script>
    import moment from "moment";
    require('moment/locale/ru');
    import { mapGetters } from "vuex";
    import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
    import {
        GET_ORDERS,
        MORE_RESTORE_ORDERS, RESTORE_ORDER
    } from "../../../core/services/store/orders.module";
    import {SET_ALERT} from "../../../core/services/store/alert.module";
    import Paginate from "../Paginate";
    export default {
        name: "ArchiveOrders",
        components: {Paginate},
        mounted(){
            this.$store.dispatch(SET_BREADCRUMB, [{ title: "Все заказы" }]);
            this.getFilter();
        },

        computed: {
            ...mapGetters({
                paginate: 'paginateGetters',
                orders: 'gettersOrders',
                load: 'getOrderLoad',
                errors: 'errorsOrders',
            }),

            selectAll: {
                get: function () {
                    return this.orders ? this.selected.length == this.orders.length : false;
                },
                set: function (value) {
                    var selected = [];

                    if (value) {
                        this.orders.forEach(function (orders) {
                            selected.push(orders.id);
                        });
                    }

                    this.selected = selected;
                }
            }
        },

        data(){
            return{
                moment:moment,
                selected: [],
                actions: null,
                filter: {
                    to: '50',
                    trashed: true,
                },
            }
        },

        methods:{
            numberWithSpaces(x){

                if (x){
                    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                } else {
                    return 0;
                }

            },

            async getFilter(){
                try {
                    await this.$store.dispatch(GET_ORDERS, {'page': this.$route.params.page, 'filter': this.filter});
                    if (this.orders.length === 0 && this.paginate.total > 0){
                        this.$router.push({ name: 'ArchiveOrder', params: {page: 1}})
                    }
                } catch (e) {
                    this.showAlert('Ошибка загрузки', 'danger', 'toast');
                }
            },

            showAlert(text, variant, type) {
                this.$store.commit(SET_ALERT, {text, variant, type});
            },

            moreActions(){
                if (this.actions === null){
                    this.showAlert('Необходимо выбрать действие', 'warning', 'toast');
                    return false
                }

                if (this.selected.length === 0){
                    this.showAlert('Необходимо выбрать хотя бы один заказ', 'warning', 'toast');
                    return false
                }

                if (this.actions === "restore" && this.selected.length > 0){
                    this.$store.dispatch(MORE_RESTORE_ORDERS, this.selected)
                        .then(() => {
                            this.getFilter();
                            this.showAlert('Заказы успешно восстановлены', 'success', 'toast');
                        })
                        .catch(() => {
                            this.showAlert('Ошибка восстановления', 'danger', 'toast');
                        })
                }
            },

            restoreOrder(id){
                this.$store.dispatch(RESTORE_ORDER, id)
                    .then(() => {
                        this.getFilter();
                        this.showAlert('Заказ успешно восстановлен', 'success', 'toast');
                    })
                    .catch(() => {
                        this.showAlert('Ошибка восстановления', 'danger', 'toast');
                    })
            },

        },

        watch: {

            $route: function () {
                this.getFilter()
            },

            "filter.to": function() {
                this.getFilter()
            },
        }
    }
</script>

<style scoped>

</style>